import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "info container d-none d-lg-block" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "number-of-stories" }
const _hoisted_6 = {
  for: "autoplay",
  class: "autoplay-label col-md-5"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  class: "nav flex-row nav-tabs",
  id: "v-pills-tab",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_9 = { class: "row w-100 align-items-center justify-content-between playlist-wrap d-lg-none" }
const _hoisted_10 = {
  for: "autoplay",
  class: "autoplay-label col-6"
}
const _hoisted_11 = { class: "number-of-stories col-6" }
const _hoisted_12 = { class: "nav-list" }

import { PlaylistStoryDto } from '@/models/PlaylistPageTypes';
import { onUpdated, computed } from 'vue';
import { usePlaylistStore } from '@/stores/playlistStore';
import PlaylistPageListOfStoriesListElement from './list-of-stories-components/PLaylistPageListOfStoriesListElement.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaylistPageListOfStories',
  props: {
    stories: null,
    title: null,
    description: null
  },
  setup(__props: any) {

const props = __props as {
    stories?: Array<PlaylistStoryDto>,
    title?: string,
    description?: string
};

const playlistStore = usePlaylistStore();



const numberOfStories = computed(() => {
    const trans =  playlistStore.getLocalization("PlaylistPage.NumberOfItems") ?? "";

    if (props.stories && props.stories.length > 0) {
        return trans.replace('{{count}}', props.stories.length.toString())
    }

    return "";
})

const autoplayLabel = computed(() => playlistStore.getLocalization("PlaylistPage.AutoplayLabel"))

onUpdated(() => {
    if (props.stories?.length) {
        playlistStore.currentElement = props.stories[0].KeyId;
        let story = document.getElementById(props.stories[0].KeyId);
        story?.click()
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(numberOfStories)), 1),
            _createElementVNode("input", {
              id: "autoplay",
              type: "checkbox",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(playlistStore).switchAutoplay && _unref(playlistStore).switchAutoplay(...args))),
              class: "checkbox-autoplay col-md-2"
            }),
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(autoplayLabel)), 1)
          ])
        ])
      ]),
      _createElementVNode("p", {
        class: "row",
        innerHTML: __props.description
      }, null, 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, [
          _createTextVNode(_toDisplayString(_unref(autoplayLabel)) + " ", 1),
          _createElementVNode("input", {
            id: "autoplay",
            type: "checkbox",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(playlistStore).switchAutoplay && _unref(playlistStore).switchAutoplay(...args))),
            class: "checkbox-autoplay col-2"
          })
        ]),
        _createElementVNode("p", _hoisted_11, [
          _createElementVNode("bdi", null, _toDisplayString(_unref(numberOfStories)), 1)
        ])
      ]),
      _createElementVNode("ol", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stories, (story) => {
          return (_openBlock(), _createBlock(PlaylistPageListOfStoriesListElement, {
            key: story.KeyId,
            stories: __props.stories,
            story: story
          }, null, 8, ["stories", "story"]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})